import { useState, useEffect, ReactNode } from 'react';

import ReactDOM from 'react-dom';

type Props = {
  children: ReactNode;
  container: Element;
};

const UniversalPortal = ({ children, container }: Props) => {
  const [isActive, setActive] = useState(false);

  // Activate the portal after the component has mounted, and the effect
  // hook is fired for the first time. This ensures that we do not attempt
  // to render the portal during SSR.
  useEffect(() => setActive(true), []);

  if (isActive && container) {
    return ReactDOM.createPortal(children, container);
  } else {
    return null;
  }
};

// eslint-disable-next-line import/no-default-export
export default UniversalPortal;
